export default __webpack_public_path__ + "locales/bg/Webhooks.json?hash=eaef46276d44f7ee7d357fbcd4dd95bf";